import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  addPlanzoneMaterialResource(
    request: Boundaries["addPlanzoneMaterialResource"]["request"],
  ): void;
}

function useAddPlanzoneMaterialResource(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isAddPlanzoneMaterialResourceRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isAddPlanzoneMaterialResourceRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isAddPlanzoneMaterialResourceRequestFailure,
    ),
    addPlanzoneMaterialResource: core.addPlanzoneMaterialResource,
  };
}

export { useAddPlanzoneMaterialResource };
